// /Users/vijayakumarreddygajjala/zninth/Ascentra-2.0/my-ascentra-app/src/Common/services/httpservice.js

// // import listData from '../data/listData.json'; // Import the data from the JSON file

// const API_BASE_URL = "http://127.0.0.1:5000/"; // Replace with your actual API base URL, e.g., "https://api.example.com"
// const API_BASE_URL1 = "https://astronode-h2a5fsfxc3fkapef.centralus-01.azurewebsites.net/";

import config from '../../config.js'; // Import the config file
// or if you used config.json
// import configData from '../../config.json';
// const config = configData[process.env.NODE_ENV || "development"];

// const API_BASE_URL = "http://127.0.0.1:5000/"; // Remove this line
// const API_BASE_URL1 = "https://astronode-h2a5fsfxc3fkapef.centralus-01.azurewebsites.net/"; // Remove this line

import httpClient, { authService } from './httpClient.js';

const API_BASE_URL = config.API_BASE_URL;

// Helper function to handle API endpoints
const getEndpoint = (path) => {
  return path.startsWith('http') ? path : `${API_BASE_URL}${path}`;
};

export const fetchData = async (endpoint, options = {}) => {
  try {
    const url = getEndpoint(endpoint);
    const method = options.method || 'GET';
    const data = options.body ? JSON.parse(options.body) : undefined;
    const headers = options.headers || {};

    let response;
    switch (method.toUpperCase()) {
      case 'GET':
        response = await httpClient.get(url, { headers });
        break;
      case 'POST':
        response = await httpClient.post(url, data, { headers });
        break;
      case 'PUT':
        response = await httpClient.put(url, data, { headers });
        break;
      case 'DELETE':
        response = await httpClient.delete(url, { headers });
        break;
      case 'PATCH':
        response = await httpClient.patch(url, data, { headers });
        break;
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }

    return response;
  } catch (error) {
    console.error("Error in fetchData:", error.message);
    throw error;
  }
};

export const deleteIntegration = async (id) => {
  return fetchData(`api/integrations/delete/${id}/`, {
    method: 'DELETE',
  });
};

export const upsertIntegration = async (id, payload, status) => {
  const updatedPayload = { ...payload, status: status };
  return fetchData(`api/integrations/upsert/${id}/`, {
    method: 'POST',
    body: JSON.stringify(updatedPayload),
  });
};

export const getIntegrations = async (page = 1, page_size = 10, status = 'All') => {
  return fetchData(`api/integrations?page=${page}&page_size=${page_size}&status=${status}`);
};

export const getIntegrationById = async (id) => {
  return fetchData(`api/integrations/${id}/`);
};

export const signupUser = async (userData) => {
  return fetchData("api/users/signup/", {
    method: 'POST',
    body: JSON.stringify(userData),
  });
};

export const loginUser = async (userData) => {
  const response = await fetchData("api/users/login/", {
    method: 'POST',
    body: JSON.stringify(userData),
  });
  
  // Store tokens using authService
  if (response.access && response.refresh) {
    authService.setTokens({
      access: response.access,
      refresh: response.refresh
    });
  }
  
  return response;
};

export const verifyEmailToken = async (token) => {
  return fetchData(`api/users/verify-email/${token}/`);
};

/**
 * Fetches the current authenticated user's profile.
 * @param {string} accessToken - The JWT access token.
 * @returns {Promise<any>} A promise that resolves with the user profile data.
 */
// export const getMyProfile = async (accessToken) => {
//   const endpoint = "api/users/me/"; // Adjust if your profile endpoint is different
//   console.log("getMyProfile accessToken:", accessToken); // DEBUG LINE
//   return fetchData(endpoint, {
//     method: 'GET',
//     headers: {
//       'Authorization': `Bearer ${accessToken}`,
//     },
//   });
// };

export const getMyProfile = async () => {
  return fetchData("api/users/me/", {
    method: 'GET'
  });
};


// export const getUserInfo = async (userId) => {
//   return fetchData(`users/${userId}`);
// };
// export const getUserIntegrations = async (userId) => {
//   return fetchData(`users/${userId}/integrations`);
// };
// export const getUserIntegrationById = async (userId, integrationId) => {
//   return fetchData(`users/${userId}/integrations/${integrationId}`);
// };
// export const getUserIntegrationRunHistory = async (userId, integrationId) => {
//   return fetchData(`users/${userId}/integrations/${integrationId}/runhistory`);
// };
// export const getUserIntegrationRunLogData = async (userId, integrationId) => {
//   return fetchData(`users/${userId}/integrations/${integrationId}/runlogdata`);
// };

// export const getSample = async (id) => {
//     const options = {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//       }
//       };

//     // const response = await fetch('https://astronode-h2a5fsfxc3fkapef.centralus-01.azurewebsites.net/', options);
//     const response = await fetch('http://127.0.0.1:5000/integrations', options);


//     const data = await response.json();

//     return data;

//   //return fetchData(`http://127.0.0.1:5001/ascentraapp/us-central1/on_request_example`);
// };

// Helper function to generate a random integer within a range
const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// Helper function to generate a random date within a range
const getRandomDate = (start, end) => {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};

const getRandomStatus = () => {
  const statuses = ["Success", "Failed"];//, "Pending"
  return statuses[Math.floor(Math.random() * statuses.length)];
};


const getRandomLogStatus = () => {
  const statuses = ["Info", "Warning", "Error"];
  return statuses[Math.floor(Math.random() * statuses.length)];
}

const getRandomLogMessage = () => {
  const messages = [
    "Received request from client",
    "Invalid request payload",
    "Internal server error",
    "Request timed out",
    "Authentication failed",
    "Access denied",
    "Resource not found",
    "Database connection error",
    "Invalid token",
    "Session expired",
    "Invalid credentials",
    "Permission denied",
    "Invalid input data",
    "Server overloaded",
    "Service unavailable",
    "Unknown error",
    "Fetched 10 records",
    "Updated user profile",
    "Deleted record",
  ];
  return messages[Math.floor(Math.random() * messages.length)];
}

export const getRunHistory = async (id, page, page_size) => {
  return fetchData(`api/integrations/runhistory/${id}?page=${page}&&page_size=${page_size}`);
}

export const getLogData = async (id) => {
  // Simulate a network delay (e.g., 1 second)
  await new Promise((resolve) => setTimeout(resolve, 1000));

  const logData = [];
  // const startDate = new Date(2024, 10, 20); // 20 November 2024
  // const endDate = new Date(); // Today's date

  // for (let i = 0; i < 250; i++) {
  //   const randomDate = getRandomDate(startDate, endDate);
  //   logData.push({
  //     date: randomDate.toISOString(), // Format as ISO string
  //     status: getRandomLogStatus(),
  //     message: getRandomLogMessage(),
  //   });
  // }

  // Sort the logData array by date in descending order
  logData.sort((a, b) => new Date(b.date) - new Date(a.date));

  return logData;
}

export const getRunLogData = async (id) => {
  return fetchData(`api/integrations/runlogdata/${id}`);
}

// Add more service functions for other API endpoints as needed
